import React from 'react';

export default class ItemTreino extends React.Component{
  render(){
    return(
      <a
      className='item-treino'
        href='#'
        onClick={this.props.onClick}
      >
      {this.props.data.nome}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/treino/ItemTreino.js